import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { Profile, User } from "types";
import type { RootState } from "../store";

// Define a type for the slice state
interface UserState {
  user: User;
  profile: User & Profile;
}

// Define the initial state using that type
const initialState: UserState = {
  user: {
    email: "",
    id: "",
    isVerified: false,
    joinedAt: new Date(),
    name: "",
    password: "",
    phoneNumber: 0,
    surname: "",
    username: "",
    roleId: 2,
    status: "OFFLINE",
    isPaid: false,
    isBlocked: false,
    matricule: 0,
  },
  profile: {
    image: "",
    birthdate: new Date(),
    lastModifiedOn: new Date(),
    level: 0,
    rating: 0,
    userId: "",
    email: "",
    id: "",
    roleId: 2,
    isVerified: false,
    joinedAt: new Date(),
    name: "",
    password: "",
    phoneNumber: 0,
    surname: "",
    username: "",
    status: "OFFLINE",
    isPaid: false,
    isBlocked: false,
    matricule: 0,
  },
};

export const userSlice = createSlice({
  name: "user",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setUser: (state, action: PayloadAction<User>) => {
      state.user = action.payload;
    },
    setProfile: (state, action: PayloadAction<User & Profile>) => {
      state.profile = action.payload;
    },
  },
});

export const { setUser, setProfile } = userSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const getUserData = (state: RootState) => state.user.user;
export const getProfileData = (state: RootState) => state.user.profile;
export default userSlice.reducer;
